import styled from "styled-components";

import { media, Card as _Card } from "@otta/design";
import { modularScale } from "@otta/design-tokens";

export const SplitContent = styled.div`
  padding: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: ${modularScale(-2)} 0;

  ${media({ from: "tablet" })`
    padding: ${modularScale(2)} 0;
    flex-direction: row;
    justify-content: space-around;
  `}
`;

export const WideCard = styled(_Card)`
  width: 100%;
  padding-bottom: ${modularScale(-2)};
  margin-bottom: ${modularScale()};
`;

export const PageContainer = styled.div`
  margin: 0 auto;
  max-width: 1024px;
  padding: 0 ${modularScale()};
`;
